import { TaskCategory, TaskConfiguration, TimeCategory } from '../context/GlobalContext'
import { useSettings } from './useSettings'
import { useMemo } from 'react'
import { ResolvedTaskDateConfig, resolveTaskDateConfig } from '../helpers/taskDateHelper'

export type TaskCategoriesProps = TaskConfiguration & {
    loaded: boolean
    defaultCategory?: TimeCategory
    getCategoryById: (key: string) => TaskCategory
    /** The date handling of the office with all defaults filled in (HAM-4286). */
    dateConfig: ResolvedTaskDateConfig
}

export default function useTasks(): TaskCategoriesProps {
    const { settings } = useSettings()
    const loaded = useMemo(() => settings?.task !== undefined, [settings])
    const categories = useMemo(() => settings?.task?.categories || [], [settings])
    const defaultCategory = useMemo(() => categories.find(category => category.isDefault), [settings, settings?.task?.categories])
    const getCategoryById: TaskCategoriesProps['getCategoryById'] = (key: string): TaskCategory => categories.find(category => category.key === key)
    const dateConfig = useMemo(() => resolveTaskDateConfig(settings?.task), [settings?.task])

    return {
        loaded,
        defaultCategory: defaultCategory,
        getCategoryById,
        categories: categories,
        dateConfig,
    }
}
